import React, {Fragment, useEffect, useState} from "react";
import {DragDropContext} from "react-beautiful-dnd";
import YuJaButton from "../../components/standardization/YuJaButton";
import {ReactComponent as PlusIcon} from "../../images/plus.svg";
import {ReactComponent as ARROW} from "../../images/arrow_right_black.svg";
import {
    ADD_DISTRACTORS_TEXT,
    ADD_MATCHING_PAIR_TEXT,
    CORRECT_RESPONSE_TEXT,
    DISTRACTOR_TEXT,
    GRADE_SCHEMA,
    MAXIMUM_MH_OPTIONS_ERROR,
    PREMISE,
    RESPONSE_TEXT,
} from "../../utils/constants";
import {findFirstOverflowParent, notifyError, reorderKeysByDragDrop} from "../../utils/helpers";
import {addDistractorToQuestion, addPremiseToQuestion, convertMHOptionMap} from "../../utils/questionUtils";
import "../styles.css";
import classes from "../questions.module.css";
import PremiseNew from "./PremiseNew";
import ResponseNew from "./ResponseNew";

export default function MHQuestionNew({
                                          gradeSchema=GRADE_SCHEMA.GRADED.key,
                                          setQuestions,
                                          questions,
                                          selectedQuestion,
                                          questionBuilder = false,
                                          disabled = false
                                      }) {
    const {serialNo, correctAnswers = [], weightage} = selectedQuestion;
    const gradeEnable = gradeSchema !== GRADE_SCHEMA.UNGRADED.key && !!weightage;

    const initializeCollapse = () => {
        const res = {};

        correctAnswers.forEach((option, index) => {
            if (option.length === 1) {
                res[index] = [true];
            } else {
                res[index] = [true, true];
            }

        });
        return res;
    }

    const [collapseStatusObj, setCollapseStatusObj] = useState(() => initializeCollapse());

    useEffect(() => {
        setCollapseStatusObj(initializeCollapse);
    }, [serialNo]);


    useEffect(() => {
        if (correctAnswers.length > Object.keys(collapseStatusObj).length) {
            let copyArr = [];
            let matchingPairs = correctAnswers.filter(item => item.length > 1);
            let matchingPairsStatusArr = Object.values(collapseStatusObj).filter(item => item.length > 1);
            matchingPairs.forEach((item, index) => {
                if (!!matchingPairsStatusArr[index] && matchingPairsStatusArr[index].length === item.length) {
                    copyArr.push(matchingPairsStatusArr[index]);
                } else {
                    copyArr.push(item.length === 1 ? [true] : [true, true]);
                }
            })

            let distractors = correctAnswers.filter(item => item.length === 1);
            let distractorsStatusArr = Object.values(collapseStatusObj).filter(item => item.length === 1);

            distractors.forEach((item, index) => {
                if (!!distractorsStatusArr[index] && distractorsStatusArr[index].length === item.length) {
                    copyArr.push(distractorsStatusArr[index]);
                } else {
                    copyArr.push([true]);
                }
            })

            let copy = {};
            copyArr.forEach((option, index) => {
                copy[index] = option;
            });
            setCollapseStatusObj(copy);
        }
    }, [correctAnswers]);

    const handleOrderChange = (result) => {
        if (!result.destination) {
            return;
        }
        const fromId = result.source.droppableId;
        const toId = result.destination.droppableId;
        if (fromId === toId) {
            return;
        }

        let fromResource = fromId.split("_")[0];
        let toResource = toId.split("_")[0];
        if (fromResource !== toResource) {
            return;
        }


        let fromIndex = parseInt(fromId.split("_")[1]);
        let toIndex = parseInt(toId.split("_")[1]);

        let newQuestions = [];
        let copyObj = {};
        questions.forEach((q) => {
            if (q.serialNo !== serialNo) {
                newQuestions.push(q);
            } else {
                const questionCopy = JSON.parse(JSON.stringify(q));
                let reorderKeys = reorderKeysByDragDrop(fromIndex, toIndex,
                    Array.from({length: correctAnswers.length}, (_, i) => i)
                );
                // let newOptionsMap = [];
                let newCorrectAnswers = [];
                for (let i = 0; i < reorderKeys.length; i++) {
                    let idx = reorderKeys[i];
                    if (fromResource === "premise") {
                        let replaceVal = correctAnswers[idx][0];
                        let replaceVal2 = collapseStatusObj[idx][0];
                        if (correctAnswers[i].length === 1) {
                            newCorrectAnswers.push([correctAnswers[i][0]]);
                            copyObj[i] = [collapseStatusObj[i][0]];
                        } else {
                            newCorrectAnswers.push([replaceVal, correctAnswers[i][1]]);
                            copyObj[i] = [replaceVal2, collapseStatusObj[i][1]];
                        }
                    } else {
                        let replaceVal = correctAnswers[idx].length > 1 ? correctAnswers[idx][1] : correctAnswers[idx][0];
                        let replaceVa2 = collapseStatusObj[idx].length > 1 ? collapseStatusObj[idx][1] : collapseStatusObj[idx][0];
                        if (correctAnswers[i].length === 1) {
                            newCorrectAnswers.push([replaceVal]);
                            copyObj[i] = [replaceVa2];
                        } else {
                            newCorrectAnswers.push([correctAnswers[i][0], replaceVal]);
                            copyObj[i] = [collapseStatusObj[i][0], replaceVa2];
                        }
                    }
                }

                questionCopy.optionsMap = convertMHOptionMap(newCorrectAnswers);
                questionCopy.correctAnswers = newCorrectAnswers;
                newQuestions.push(questionCopy);

            }
        });

        setCollapseStatusObj(copyObj);
        setQuestions(newQuestions);
    };

    const handleDeleteOption = (idx) => {
        let newQuestions = [];

        const collapseArr = [];
        questions.forEach((q) => {
            if (q.serialNo !== serialNo) {
                newQuestions.push(q);
            } else {
                const questionCopy = JSON.parse(JSON.stringify(q));
                let newCorrectAnswers = [];
                for (let i = 0; i < questionCopy.correctAnswers.length; i++) {
                    if (parseInt(idx) !== i) {
                        newCorrectAnswers.push(questionCopy.correctAnswers[i]);
                        collapseArr.push(collapseStatusObj[i]);
                    }
                }
                questionCopy.optionsMap = convertMHOptionMap(newCorrectAnswers);
                questionCopy.correctAnswers = newCorrectAnswers;
                newQuestions.push(questionCopy);
            }
        });

        let copy = {};
        collapseArr.forEach((option, index) => {
            copy[index] = option;
        });
        setCollapseStatusObj(copy);
        setQuestions(newQuestions);
    };


    const addDistractor = () => {
        const newQuestions = addDistractorToQuestion(selectedQuestion, questions);
        if (newQuestions) {
            let que = newQuestions.find(q => q.serialNo === selectedQuestion.serialNo);
            que.optionsMap = convertMHOptionMap(que.correctAnswers);
            setQuestions(newQuestions);
        } else {
            notifyError(MAXIMUM_MH_OPTIONS_ERROR);
        }
    }

    const addMatchingPair = () => {
        const newQuestions = addPremiseToQuestion(selectedQuestion, questions);
        if (newQuestions) {
            let que = newQuestions.find(q => q.serialNo === selectedQuestion.serialNo);
            que.optionsMap = convertMHOptionMap(que.correctAnswers);
            setQuestions(newQuestions);
        } else {
            notifyError(MAXIMUM_MH_OPTIONS_ERROR);
        }
    }

    let showDistractorLabel = correctAnswers.filter(i => i.length === 1).length !== 0 && gradeEnable;
    return (
        <div className={classes.MHGridLayoutContainer}>
            <DragDropContext onDragEnd={(result) => handleOrderChange(result)}>
                {correctAnswers.map(i => i.length > 1).length !== 0 &&
                    <>
                        <span className={classes.MHLeftContainer} style={{fontWeight: "600"}}>{PREMISE}</span>
                        <span className={classes.MHMidContainer}/>
                        <span className={classes.MHRightContainer} style={{fontWeight: "600"}}>
                            {gradeEnable ? CORRECT_RESPONSE_TEXT : RESPONSE_TEXT}
                        </span>
                    </>
                }
                {correctAnswers && correctAnswers.map((value, index) => {
                    if (value.length < 2) {
                        return <Fragment key={index}/>
                    }
                    return (
                        <Fragment key={index}>
                            <PremiseNew
                                setQuestions={setQuestions}
                                selectedQuestion={selectedQuestion}
                                index={index}
                                questions={questions}
                                optionData={value}
                                collapsed={!collapseStatusObj.hasOwnProperty(index) || collapseStatusObj[index][0]}
                                setCollapsed={(status) => {
                                    let copy = JSON.parse(JSON.stringify(collapseStatusObj));
                                    let arr = copy[index];
                                    arr[0] = status;
                                    setCollapseStatusObj(copy);
                                }}
                            />
                            <span className={classes.MHMidContainer}>
                                {gradeEnable && <ARROW/>}
                            </span>
                            <ResponseNew
                                idPrefix={"response_"}
                                setQuestions={setQuestions}
                                selectedQuestion={selectedQuestion}
                                index={index}
                                questions={questions}
                                optionData={value}
                                handleDeleteOption={handleDeleteOption}
                                collapsed={!collapseStatusObj.hasOwnProperty(index) || collapseStatusObj[index][1]}
                                setCollapsed={(status) => {
                                    let copy = JSON.parse(JSON.stringify(collapseStatusObj));
                                    let arr = copy[index];
                                    arr[1] = status;
                                    setCollapseStatusObj(copy);
                                }}
                            />
                        </Fragment>
                    );
                })}

                {showDistractorLabel &&
                    <>
                        <span className={classes.MHLeftContainer}>
                            <YuJaButton
                                title={ADD_MATCHING_PAIR_TEXT}
                                onClick={(e) => {
                                    addMatchingPair();
                                    let currentTarget = e.currentTarget;
                                    setTimeout(() => {
                                        const parent = findFirstOverflowParent(currentTarget);
                                        parent?.scroll({top: parent.scrollHeight, behavior: "smooth"});
                                    }, 100);
                                }}
                                style={{
                                    height: 35,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    alignSelf: "end"
                                }}
                            >
                              <PlusIcon style={{width: 15, height: 15, marginRight: 2}}/> {ADD_MATCHING_PAIR_TEXT}
                            </YuJaButton>
                        </span>
                        <span className={classes.MHMidContainer}/>
                        <span className={classes.MHRightContainer} style={{fontWeight: "600"}}>{DISTRACTOR_TEXT}</span>
                    </>
                }
                {correctAnswers && correctAnswers.map((value, index) => {
                    if (value.length > 1) {
                        return <Fragment key={index}/>
                    }

                    let firstIdx = correctAnswers.findIndex(i => i.length === 1);
                    return (
                        <Fragment key={index}>
                            <span className={classes.MHLeftContainer}>
                                {firstIdx === index && !showDistractorLabel &&
                                    <YuJaButton
                                        title={ADD_MATCHING_PAIR_TEXT}
                                        onClick={(e) => {
                                            addMatchingPair();
                                            let currentTarget = e.currentTarget;
                                            setTimeout(() => {
                                                const parent = findFirstOverflowParent(currentTarget);
                                                parent?.scroll({top: parent.scrollHeight, behavior: "smooth"});
                                            }, 100);
                                        }}
                                        style={{
                                            height: 35,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            alignSelf: "end"
                                        }}
                                    >
                                      <PlusIcon style={{width: 15, height: 15, marginRight: 2}}/> {ADD_MATCHING_PAIR_TEXT}
                                    </YuJaButton>
                                }
                            </span>
                            <span className={classes.MHMidContainer}/>
                            <ResponseNew
                                idPrefix={gradeEnable ? "distractor_" : "response_"}
                                setQuestions={setQuestions}
                                selectedQuestion={selectedQuestion}
                                index={index}
                                questions={questions}
                                optionData={value}
                                handleDeleteOption={handleDeleteOption}
                                collapsed={!collapseStatusObj.hasOwnProperty(index) || collapseStatusObj[index][0]}
                                setCollapsed={(status) => {
                                    let copy = JSON.parse(JSON.stringify(collapseStatusObj));
                                    let arr = copy[index];
                                    arr[0] = status;
                                    setCollapseStatusObj(copy);
                                }}
                            />
                        </Fragment>
                    );
                })}
            </DragDropContext>


            <span className={classes.MHLeftContainer}>
                {correctAnswers.filter(i => i.length === 1).length === 0 &&
                    <YuJaButton
                        title={ADD_MATCHING_PAIR_TEXT}
                        onClick={(e) => {
                            addMatchingPair();
                            let currentTarget = e.currentTarget;
                            setTimeout(() => {
                                const parent = findFirstOverflowParent(currentTarget);
                                parent?.scroll({top: parent.scrollHeight, behavior: "smooth"});
                            }, 100);
                        }}
                        style={{
                            height: 35,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            alignSelf: "end"
                        }}
                    >
                      <PlusIcon style={{width: 15, height: 15, marginRight: 2}}/> {ADD_MATCHING_PAIR_TEXT}
                    </YuJaButton>
                }
            </span>
            <span className={classes.MHMidContainer}/>
            <span className={classes.MHRightContainer}>
                <YuJaButton
                    title={ADD_DISTRACTORS_TEXT}
                    onClick={(e) => {
                        addDistractor();
                        let currentTarget = e.currentTarget;
                        setTimeout(() => {
                            const parent = findFirstOverflowParent(currentTarget);
                            parent?.scroll({top: parent.scrollHeight, behavior: "smooth"});
                        }, 100);
                    }}
                    style={{
                        height: 35,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        alignSelf: "end"
                    }}
                >
                    <PlusIcon style={{width: 15, height: 15, marginRight: 2}}/> {ADD_DISTRACTORS_TEXT}
                </YuJaButton>
            </span>
        </div>
    );
}